<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <rect width="12" height="6" x="8" y="23" fill="#bf360c" />
    <path
      fill="#ef8d3c"
      d="M42,17.5c0,0.8-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5C41.3,16,42,16.7,42,17.5 M29,17.5 c0-0.8-0.7-1.5-1.5-1.5S26,16.7,26,17.5s0.7,1.5,1.5,1.5S29,18.3,29,17.5"
    />
    <path
      fill="#2196f3"
      d="M37.8,26L37.8,26L34,26.8L30.2,26c0,0-8.2,1.5-8.2,10h24C46,27.6,37.8,26,37.8,26"
    />
    <path fill="#ef8d3c" d="M34,30c-4,0-4-4-4-4v-4h8v4C38,26,38,30,34,30z" />
    <path
      fill="#ffaa45"
      d="M41,12c0-5.9-14-3.8-14,0v6.1c0,3.8,3.1,6.9,7,6.9c3.9,0,7-3.1,7-6.9V12z"
    />
    <path fill="#ff9800" d="M18,30c0,0,0,4-4,4s-4-4-4-4" />
    <path
      fill="#66bb6a"
      d="M17.8,30L17.8,30L14,30.8L10.2,30c0,0-8.2,1.5-8.2,10h24C26,31.6,17.8,30,17.8,30"
    />
    <path
      fill="#0d47a1"
      d="M34.1,32c3.1,0,5.6-2.3,5.9-5.2c-0.9-0.4-1.6-0.6-2-0.7c0,2.2-1.8,3.9-4,3.9c-2.2,0-4-1.8-4-3.9  c-0.4,0.1-1.1,0.3-2,0.7C28.5,29.7,31,32,34.1,32z"
    />
    <path fill="#ff9800" d="M14,34c-4,0-4-4-4-4v-4h8v4C18,30,18,34,14,34z" />
    <path
      fill="#ffb74d"
      d="M21,17.7c0-5.9-14-3.8-14,0v4.4c0,3.8,3.1,6.9,7,6.9c3.9,0,7-3.1,7-6.9V17.7z"
    />
    <path
      fill="#2e7d32"
      d="M14,36c3.1,0,5.6-2.3,5.9-5.2c-0.9-0.4-1.6-0.6-2-0.7c0,2.2-1.8,3.9-4,3.9s-4-1.8-4-3.9c-0.4,0.1-1.1,0.3-2,0.7 C8.4,33.7,10.9,36,14,36z"
    />
    <path
      fill="#424242"
      d="M34,6c-4.9,0-8,4.3-8,8.2V16l2,2v-4l9.2-3l2.8,3v4l2-2v-0.8c0-3.2-0.8-6.8-4.8-7.6L36.4,6H34z"
    />
    <path
      fill="#ff5722"
      d="M14,11C4,11,4,25,4,25l4,4v-9l9.2-5l2.8,3v11l4-4c0,0,0-13-7-13l-1-1H14z"
    />
    <path
      fill="#784719"
      d="M16,21c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S16,21.6,16,21 M10,21c0,0.6,0.4,1,1,1s1-0.4,1-1s-0.4-1-1-1  S10,20.4,10,21"
    />
    <path
      fill="#784719"
      d="M36,17c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S36,17.6,36,17"
    />
    <path
      fill="#784719"
      d="M30,17c0,0.6,0.4,1,1,1s1-0.4,1-1s-0.4-1-1-1S30,16.4,30,17"
    />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "MaleFemaleUserGroupIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
